import constructEnterpriseDomain from 'utils/construct-enterprise-domain';

export const ENTERPRISE_LIST_URL = `${constructEnterpriseDomain()}/enterprises`;

export const goToEnterpriseList = () => {
  window.location.href = ENTERPRISE_LIST_URL;
};
